import { render, staticRenderFns } from "./NetworkWallets.vue?vue&type=template&id=8f9e01b0&scoped=true"
import script from "./NetworkWallets.vue?vue&type=script&lang=js"
export * from "./NetworkWallets.vue?vue&type=script&lang=js"
import style0 from "./NetworkWallets.vue?vue&type=style&index=0&id=8f9e01b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9e01b0",
  null
  
)

export default component.exports